export default __webpack_public_path__ + "static/media/Ballroll_00065.9fd3c7cd.png";